export default [
    {
        path: 'permission',
        component: () => import('@/views/organization/permission/permission'),
    },
    // {
    //     path: 'permission/menu',
    //     component: () => import('@/views/organization/permission/permission-menu/menu.main'),
    //     children: [
    //         {
    //             name: 'v3',
    //             path: 'v3',
    //             components: {
    //                 v3: () => import('@/views/organization/permission/permission-menu/menu.layout')
    //             }
    //         },
    //         {
    //             name: 'v2',
    //             path: 'v2',
    //             components: {
    //                 v2: () => import('@/views/organization/permission/permission-menu/menu.layout.v2')
    //             }
    //         },
    //         {
    //             name: 'v1',
    //             path: 'v1',
    //             components: {
    //                 v1: () => import('@/views/organization/permission/permission-menu/menu.layout.v1')
    //             }
    //         }
    //     ],
    //     redirect: 'permission/menu/v3'
    // },
    // {
    //     path: 'permission/resource',
    //     component: () => import('@/views/organization/permission/permission-resource/resource.main'),
    //     children: [
    //         {
    //             name: 'resourceList',
    //             path: 'list',
    //             components: {
    //                 list: () => import('@/views/organization/permission/permission-resource/permission.resource.list'),
    //             },
    //         },
    //         {
    //             name: 'resourceDetail',
    //             path: 'detail',
    //             components: {
    //                 detail: () => import('@/views/organization/permission/permission-resource/permission.resource.detail'),
    //             },
    //         }
    //     ],
    //     redirect: 'permission/resource/list'
    // }
]
